<ng-template #template>
    <div class="modal-header">
      <h4 class="modal-title">
        {{'Session Timeout!' | translate}}  
      </h4>
    </div>
    <div class="modal-body">
      <div>{{"You're being timed out due to inactivity. Please choose to stay signed in or to logoff." | translate}}</div>
      <button type="button" class="btn btn-sm btnDelete mr-2" (click)="logout()">
        {{'Logout' | translate}} 
      </button>
      <button type="button" class="btn btn-sm btnCancel" (click)="sessionReset()">
        {{'Stay Logged in' | translate}} 
      </button>
      <br>
      <p>{{'Time remaining to logout:' | translate}} {{secs}}</p>
    </div>
  </ng-template>
  